import React from 'react';
import { GetServerSidePropsContext } from 'next';
import LayoutApp from '@zmedia/bm-soccer-ui/layout';
import { TeamPageView } from '@zmedia/bm-soccer-ui/modules/team';
import PageCustomService from '@zmedia/bm-soccer-ui/service/PageCustomService';
import { IResponse } from 'src/interface';
import { ContainerUI } from 'src/layout/ui';
import { ContentItem } from 'src/modules/content/components/item/ContentItem';

export function TeamPage({
    resp,
    isBot,
}: {
    resp: IResponse<any>;
    isBot: boolean;
}) {
    const { data } = resp;
    const listProps = {
        ContentItem: ContentItem,
        ContentItemProps: {
            lazyloadImage: !isBot,
        },
    };
    return (
        <>
            <ContainerUI {...data} />
            <LayoutApp isMobile={true} {...data}>
                <TeamPageView {...data} listProps={listProps} />
            </LayoutApp>
        </>
    );
}

export async function getServerSideProps(
    ctx: GetServerSidePropsContext
): Promise<any> {
    const id = ctx?.params?.id;
    const tab = ctx?.params?.tab;
    const resp = await PageCustomService.get(ctx, 'team', { id: id, tab: tab });
    return {
        props: {
            ...resp.props,
            isBlankLayout: true,
        },
    };
}

export default TeamPage;
